import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import QRCode from 'qrcode';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
  selector: 'app-mfa-setup',
  standalone: false,
  templateUrl: './mfa-setup.component.html',
  styleUrls: ['./mfa-setup.component.scss']
})
export class MfaSetupComponent implements OnInit {

  qrImage: string | null = null;
  manualCode: string = '';
  code = '';
  isLoading = false;
    userId: any;
    

  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router,
    private configurations: ConfigurationService
  ) { }

  ngOnInit(): void {
    this.userId = this.route.snapshot.queryParamMap.get('userId');
    this.generateMfa();
  }

  generateMfa(): void {

    this.isLoading = true;

    this.http.post<any>(this.configurations.baseUrl + '/api/account/mfa/setup', { userId: this.userId })
      .subscribe({
        next: async resp => {

          this.manualCode = resp.manualCode;

          this.qrImage = await QRCode.toDataURL(resp.qrCodeUrl);

          this.isLoading = false;
        },
        error: err => {
          this.isLoading = false;
          this.alertService.showStickyMessage(
            'Error',
            'Failed to generate MFA setup.',
            MessageSeverity.error,
            err
          );
        }
      });
  }

  confirm(): void {

    if (!this.code || this.code.length !== 6) {
      this.alertService.showMessage(
        'Invalid Code',
        'Enter valid 6-digit code.',
        MessageSeverity.error
      );
      return;
    }

    this.isLoading = true;

    this.http.post(this.configurations.baseUrl + '/api/account/mfa/confirm', {
      userId: this.userId,
      code: this.code
    })
      .subscribe({
        next: () => {
          this.isLoading = false;

          this.alertService.showMessage(
            'Success',
            'MFA enabled successfully!',
            MessageSeverity.success
          );
          this.router.navigate(['/']);
          this.code = '';
        },
        error: err => {
          this.isLoading = false;
          this.alertService.showStickyMessage(
            'Invalid Code',
            'Code verification failed.',
            MessageSeverity.error,
            err
          );
        }
      });
  }
}
